import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { UncontrolledTooltip } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import moment from 'moment';
import { detect } from 'detect-browser';

import { capitalizeFirstLetter } from '../../../util/text';

import { setEnvironment } from '../AppActions';

class EnvironmentChecker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            network: {},
            devices: [],
            browser: {},
        };
    }

    componentDidMount() {
        this.checkOnline();
        this.checkDevices();
        this.checkBrowser();

        window.addEventListener && window.addEventListener('offline', this.checkOnline);
        window.addEventListener && window.addEventListener('online', this.checkOnline);

        if(window.navigator && window.navigator.mediaDevices) {
            window.navigator.mediaDevices.ondevicechange = this.checkDevices;
        }
    }

    componentWillUnmount() {
        window.removeEventListener && window.removeEventListener('offline', this.checkOnline);
        window.removeEventListener && window.removeEventListener('online', this.checkOnline);
    }

    checkOnline = () => {
        if(window.navigator && typeof window.navigator.onLine !== 'undefined') {
            // console.log(window.navigator);
            this.setState({
                network: {
                    isOnline: window.navigator.onLine,
                    downlink: (navigator.connection || {}).downlink || '',
                    type: (navigator.connection || {}).type || '',
                    effectiveType: (navigator.connection || {}).effectiveType || '',
                    lastEdit: moment.utc().format(),
                },
            }, () => this.props.dispatch(setEnvironment(this.state)));
        }
    };

    checkDevices = () => {
        if(window.navigator && window.navigator.mediaDevices && window.navigator.mediaDevices.enumerateDevices) {
            window.navigator.mediaDevices.enumerateDevices().then(devices => {
                // console.log(devices);
                this.setState({
                    devices,
                    lastEdit: moment.utc().format(),
                }, () => this.props.dispatch(setEnvironment(this.state)));
            });
        }
    };

    checkBrowser = () => {
         const browser = detect();
         this.setState({
             browser: {
                 ...browser,
                 device: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ? 'mobile' : 'desktop',
                 lastEdit: moment.utc().format(),
             },
         }, () => this.props.dispatch(setEnvironment(this.state)));
    };

    render() {
        const { network, browser, devices } = this.state;
        return (
            <div>
                <FontAwesomeIcon icon="broadcast-tower" className={`text-${network.isOnline ? '' : 'danger blink'}`} id="environment-checker-isonline" aria-label="Réseau" />
                <UncontrolledTooltip target="environment-checker-isonline">
                    {network.isOnline ? (
                        <Fragment>
                            <FormattedMessage id="online" defaultMessage="Online" /> {false && (network.effectiveType || network.type)} {false && network.downlink && `(${network.downlink}mbps)`}
                        </Fragment>
                    ) : <FormattedMessage id="offline" defaultMessage="Offline" />}
                </UncontrolledTooltip>

                {browser.device && (
                    <Fragment>
                        {' '} <FontAwesomeIcon icon={browser.device} id="environment-checker-browser" aria-label="Navigateur" />
                        <UncontrolledTooltip target="environment-checker-browser">
                            {`${browser.os} ${capitalizeFirstLetter(browser.name)} v${browser.version}`}
                        </UncontrolledTooltip>
                    </Fragment>
                )}

                {(devices.filter(device => device.kind === 'audiooutput') || []).length > 0 && (
                    <Fragment>
                        {' '} <FontAwesomeIcon icon="headphones" className={`text-${devices.find(device => device.kind === 'audiooutput') ? '' : 'light'}`} id="environment-checker-headphones" aria-label="Audio" />
                        <UncontrolledTooltip target="environment-checker-headphones">
                            {(devices.filter(device => device.kind === 'audiooutput') || []).map(device => device.label).map(label => <span key={label}>{label}<br /></span>)}
                        </UncontrolledTooltip>
                    </Fragment>
                )}

                {(devices.filter(device => device.kind === 'audioinput') || []).length > 0 && (
                    <Fragment>
                        {' '} <FontAwesomeIcon icon="microphone" className={`text-${devices.find(device => device.kind === 'audioinput') ? '' : 'light'}`} id="environment-checker-microphone" aria-label="Microphone" />
                        <UncontrolledTooltip target="environment-checker-microphone">
                            {(devices.filter(device => device.kind === 'audioinput') || []).map(device => device.label).map(label => <span key={label}>{label}<br /></span>)}
                        </UncontrolledTooltip>
                    </Fragment>
                )}

                {(devices.filter(device => device.kind === 'videoinput') || []).length > 0 && (
                    <Fragment>
                        {' '} <FontAwesomeIcon icon="camera" className={`text-${devices.find(device => device.kind === 'videoinput') ? '' : 'light'}`} id="environment-checker-camera" aria-label="Caméra" />
                        <UncontrolledTooltip target="environment-checker-camera">
                            {(devices.filter(device => device.kind === 'videoinput') || []).map(device => device.label).map(label => <span key={label}>{label}<br /></span>)}
                        </UncontrolledTooltip>
                    </Fragment>
                )}
            </div>
        );
    }
}

function mapStateToProps(store, props) {
    return {

    };
}

EnvironmentChecker.propTypes = {
    dispatch: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(EnvironmentChecker);
